
export const AMAPI_UsbDataAccess_Enums = {
    usbDataAccessUnspecified: "USB_DATA_ACCESS_UNSPECIFIED",   // 未指定
    allowUsbDataTransfer: "ALLOW_USB_DATA_TRANSFER",       // 許可
    disAllowUsbFileTransfer: "DISALLOW_USB_FILE_TRANSFER",    // 禁止(弱)
    disAllowUsbDataTransfer: "DISALLOW_USB_DATA_TRANSFER"     // 禁止(強)
}
export type AMAPI_UsbDataAccessState = typeof AMAPI_UsbDataAccess_Enums[keyof typeof AMAPI_UsbDataAccess_Enums]

export const AMAPI_ConfigureWifi_Enums = {
    configureWifiUnspecified: "CONFIGURE_WIFI_UNSPECIFIED",   // 未指定
    allowConfiguringWifi: "ALLOW_CONFIGURING_WIFI",       // 許可
    disAllowAddWifiConfig: "DISALLOW_ADD_WIFI_CONFIG",     // 禁止(弱)
    disallowConfiguringWifi: "DISALLOW_CONFIGURING_WIFI"     // 禁止(強)
}
export type AMAPI_ConfigureWifiState = typeof AMAPI_ConfigureWifi_Enums[keyof typeof AMAPI_ConfigureWifi_Enums]

export const AMAPI_EnterpriseType_Enums = {
    enterpriseTypeUnspecified: "ENTERPRISE_TYPE_UNSPECIFIED",                  // 未指定
    managedGoogleDomain: "MANAGED_GOOGLE_DOMAIN",                        // 新方式
    managedGooglePlayAccountsEnterprise: "MANAGED_GOOGLE_PLAY_ACCOUNTS_ENTERPRISE",      // 旧方式
}
export type AMAPI_EnterpriseType_Enums = typeof AMAPI_EnterpriseType_Enums[keyof typeof AMAPI_EnterpriseType_Enums]

// CredentialProviderPolicyDefault:資格情報プロバイダーポリシーのデフォルト
export const AMAPI_CredentialProviderPolicyDefault_Enums = {
    credentialProviderPolicyDefaultUnspecified: "CREDENTIAL_PROVIDER_POLICY_DEFAULT_UNSPECIFIED",             // 指定なし。デフォルトは CREDENTIAL_PROVIDER_DEFAULT_DISALLOWED です。
    credentialProviderDefaultDisallowed: "CREDENTIAL_PROVIDER_DEFAULT_DISALLOWED",                     // credentialProviderPolicyが指定されていないアプリは、認証情報プロバイダーとして機能することは許可されていません。
    credentialProviderDefaultDisallowedExceptSystem: "CREDENTIAL_PROVIDER_DEFAULT_DISALLOWED_EXCEPT_SYSTEM",       // credentialProviderPolicyが未指定のアプリは、OEMデフォルトの認証情報プロバイダーを除き、認証情報プロバイダーとして機能することはできません。OEMデフォルトの認証情報プロバイダーは、常に認証情報プロバイダーとして機能することが許可されています。
} as const;
export type AMAPI_CredentialProviderPolicyDefault_Enums = typeof AMAPI_CredentialProviderPolicyDefault_Enums[keyof typeof AMAPI_CredentialProviderPolicyDefault_Enums]

// CredentialProviderPolicy:アプリがAndroid 14以降で認証情報プロバイダーとして機能することが許可されているかどうか。
export const AMAPI_CredentialProviderPolicy_Enums = {
    credentialProviderPolicyUnspecified: "CREDENTIAL_PROVIDER_POLICY_UNSPECIFIED",             // 未指定。動作はcredentialProviderPolicyDefaultによって制御されます。
    credentialProviderAllowed: "CREDENTIAL_PROVIDER_ALLOWED",                        // アプリは認証情報プロバイダーとして機能することが許可されています。
} as const;
export type AMAPI_CredentialProviderPolicy_Enums = typeof AMAPI_CredentialProviderPolicy_Enums[keyof typeof AMAPI_CredentialProviderPolicy_Enums]
export function isAMAPI_CredentialProviderPolicy_Enums(rawData: unknown): rawData is AMAPI_CredentialProviderPolicy_Enums {
    return Object.values(AMAPI_CredentialProviderPolicy_Enums).includes(rawData as AMAPI_CredentialProviderPolicy_Enums)
}

// AuthenticationType:The authentication type of the user on the device.
export const AMAPI_AuthenticationType_Enums = {
    authentication_type_unspecified: "AUTHENTICATION_TYPE_UNSPECIFIED",
    authentication_type_not_enforces: "AUTHENTICATION_TYPE_NOT_ENFORCED",
    googleAuthEnticated: "GOOGLE_AUTHENTICATED",
} as const;
export type AMAPI_AuthenticationType_Enums = typeof AMAPI_AuthenticationType_Enums[keyof typeof AMAPI_AuthenticationType_Enums]
export function isAMAPI_AuthenticationType_Enums(rawData: unknown): rawData is AMAPI_AuthenticationType_Enums {
    return Object.values(AMAPI_AuthenticationType_Enums).includes(rawData as AMAPI_AuthenticationType_Enums)
}